import angular from 'angular';

export const viewsModule = angular.module(
  'portainer.docker.react.views',
  []
).name;
